import { TYPE_NONE } from "@components/Form";

import type { Input } from "../types";

const FIELD_NAMES = [
  "isLiabilityAccepted",
  "hasPurchasedExemptSecurities",
  "membershipInterestsTitle",
  "sdiraType",
  "shouldCustodianSign",
  "entityName",
  "hasEinNumber",
  "einNumber",
  "custodianId",
  "accountName",
  "custodianName",
  "custodianAddress",
  "custodianEinNumber",
];

// Every SDIRA profile field as a hidden input, keyed by the field name.
const getProfileSdiraInputsMap = (): Record<string, Input> => {
  const inputsMap: Record<string, Input> = {};

  for (const name of FIELD_NAMES) {
    inputsMap[name] = { name, type: TYPE_NONE };
  }

  return inputsMap;
};

export default getProfileSdiraInputsMap;
